import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap'
import '~/scss/app.scss'

import { createApp } from 'vue'
import DesignLab from '~/vues/design_lab/index.vue'
import { createPinia } from 'pinia'

import Flash from '~/javascripts/flash.js';
import App from '~/javascripts/app/index.js'

new Flash();
new App();

const designLabID = "#js-design-lab";
const designLabEl = document.querySelector(designLabID);
const { designId, designMode, designVgId, designMaterialId } = designLabEl.dataset;

document.addEventListener('DOMContentLoaded', () => {
  let contentHeight = window.innerHeight;
  setVh();

  function setVh() {
    const isMobile = window.screen.width <= 768;
    const isInput = isMobile && document.querySelectorAll(".js-dl-panel-input-focuse").length != 0 && contentHeight > window.innerHeight;
    if(!isInput) contentHeight = window.innerHeight; // 如果不是input造成的resize 要更新容器高度

    // 計算實際可見區域的 1% 高度
    let vh = isInput ?
      contentHeight  * 0.01 :
      window.innerHeight * 0.01;
    // 將這個值設置為 --vh 變量
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    document.querySelector("#js-design-lab").style.height = isMobile ? `${100 * vh - 64}px` : ''
  }

  // 在頁面載入時設置高度
  window.addEventListener('load', setVh);

  // 在視窗調整大小時設置高度
  window.addEventListener('resize', setVh);

  // 在設備方向變化時設置高度
  window.addEventListener('orientationchange', setVh);
});

const DesignLabVueApp = createApp(DesignLab, {
  designId:   designId,
  designMode: designMode, // 判定初始前往design哪個mode
  designVgId: designVgId,
  designMaterialId: designMaterialId 
});
const pinia = createPinia();

DesignLabVueApp.use(pinia);
DesignLabVueApp.mount(designLabID);